(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.GalleryOnPage = global.NewHomeSource.GalleryOnPage || {};

  class ImageCountButton {
    /**
     * Initializes a new instance of the class.
     * Sets the rootNode property to null.
     */
    constructor() {
      this.rootNode = null;
    }

    /**
     * Sets the root node for the instance.
     *
     * @param {HTMLElement} rootNode - The root DOM node to be assigned.
     * @returns {this} Returns the current instance for chaining.
     */
    setRootNode(rootNode) {
      this.rootNode = rootNode;
      return this;
    }

    /**
     * Initializes the image count button by binding necessary events.
     * @returns {this} Returns the current instance for chaining.
     */
    initialize() {
      this.bindEvents();
      return this;
    }

    /**
     * Binds the click event listener to the node associated with this instance.
     * The click event will trigger the `onClick` handler, which is bound to the current context.
     */
    bindEvents() {
      const node = this.getNode();
      if (!node) {
        return;
      }
      this.onClick = this.onClick.bind(this);
      node.addEventListener('click', this.onClick);
    }

    /**
     * Returns the DOM node for the image count button component.
     *
     * @returns {Element} The element with the data-component="image-count-button" attribute, or null if not found.
     */
    getNode() {
      return this.rootNode.querySelector('[data-component="image-count-button"]');
    }

    /**
     * Returns the preferred image element within the root node.
     * Searches for a child element with the attribute `data-is-preferred-image="true"`.
     *
     * @returns {Element|null} The preferred image element if found, otherwise null.
     */
    getPreferredImage() {
      return this.rootNode.querySelector('[data-is-preferred-image="true"]');
    }

    /**
     * Handles the click event for the image count button.
     * Dispatches a custom 'galleryOnPageClick' event with the media ID of the preferred image.
     *
     * @returns {void}
     */
    onClick() {
      const mediaElement = this.getPreferredImage();
      document.body.dispatchEvent(new CustomEvent('galleryOnPageClick', {
        detail: {
          id: mediaElement ? mediaElement.dataset.mediaId : null,
          originator: 'imageCountButton',
        }
      }));
    }

    /**
     * Removes the click event listener from the associated DOM node.
     * Should be called to clean up resources when the instance is no longer needed.
     */
    destroy() {
      const node = this.getNode();
      if (!node) {
        return;
      }
      node.removeEventListener('click', this.onClick);
    }
  }

  global.NewHomeSource.GalleryOnPage.ImageCountButton = ImageCountButton;
}(window));
